export function convertToWatts(value: number | null): number | null {
  if (value === null) return null
  return value * 1000
}
